<template>
  <div>
     <app-header></app-header>
     <div class="userinfo">
        <div class="screen">
          <div :class="(type == 1 ? 'now checked' : 'now')" @click="changeAll(1);">基本信息</div>
          <div class="line"></div>
          <div :class="(type == 2 ? 'now checked' : 'now')" @click="changeAll(2);">修改密码</div>
        </div>
        <div class="basic" v-if="type == 1">
          <div class="step1" v-if="change == 1">
            <div class="title">个人资料</div>
            <div class="name">
              <div class="left">
                <div class="list">
                  <span style="width: 1.5rem;"><span class="red">*</span>姓名 :</span>
                  <input type="text" placeholder="请输入姓名" v-model="username" disabled>
                </div>
                <div class="list">
                  <span style="width: 1.5rem;"><span class="red">*</span>身份证号 :</span>
                  <input type="text" placeholder="请输入身份证号" v-model="idcard" disabled>
                </div>
              </div>
              <div class="right">
                <img class="default" v-if="!!headurl" :src="headurl" alt="">
                <img class="default" v-if="!headurl" src="../assets/images/head.png" alt="">
                <span class="tips">支持jpg/gif/bmp格式的图片，建议文件小于20M</span>
                <!-- <div class="btn">
                  <img src="../assets/images/header_upload.png" alt="">
                  <span @click="checkFile">上传头像</span>
                </div> -->

                <div>
                  <el-upload
                    class="upload-file"
                    accept=".jpg,.gif,.bmp,.png"
                    :action="doUpload"
                    :headers="Headers"
                    :on-change="handleChange"
                    :before-upload="beforeUpload"
                    :on-success="handleSuccess"
                    :show-file-list="false"
                    ref="newupload"
                    multiple
                    :auto-upload="true">
                    <div class="btn">
                      <img src="../assets/images/header_upload.png" alt="">
                      <span>上传头像</span>
                    </div>
                  </el-upload>
                </div>

                <!-- <input type="file" style="opacity: 0;" @focus="checkFile"> -->
              </div>
            </div>
            <div class="gender">
              <span class="text">性别 ：</span>
              <label><input type="radio" v-model="gender" value="男"/><span class="val">男</span></label>
              <label><input type="radio" v-model="gender" value="女"/><span class="val">女</span></label>
              <label><input type="radio" v-model="gender" value="保密"/><span class="val">保密</span></label>
            </div>
            <div class="intro">
              <span>个人介绍</span>
              <textarea v-model="intro" draggable="false"></textarea>
            </div>

            <div class="title">学校信息</div>
            <!-- <div class="distance">
              <span>所在地区 : </span>
              <v-distpicker @selected="sel" :province="province" :city="city" :area="area"></v-distpicker>
            </div> -->
            <div class="school">
              <div class="left">
                <span>学校名称 : </span>
                <input type="text" placeholder="请输入学校名称" v-model="school">
              </div>
              <div class="right">
                <span>上级机构 : </span>
                <input type="text" placeholder="请输入机构名称" v-model="company" disabled>
              </div>
            </div>

            <div class="mobile">
              <span class="text">手机号 : </span>
              <span class="mobile_text">{{account}}</span>
              <div class="btn" @click="toChange(2)">修改手机号</div>
              <p><img src="../assets/images/right.png" alt=""> <span>用来登陆和接收来自平台的信息，非常重要。</span></p>
            </div>
            <div class="wechat">
              <span>微信号 : </span>
              <input type="text" placeholder="请输入微信账号" v-model="wechat">
              <p>用于直播课程互动</p>
            </div>
            <div class="submit" @click="saveInfo">保存</div>
          </div>



          <div class="step2" v-if="change == 2">
            <div class="title">修改手机号</div>
            <p class="now_mobile">当前手机号 : {{account}}</p>
            <div class="list">
              <input type="text" placeholder="输入新手机号" v-model="newaccount">
            </div>
            <div class="list">
              <input type="text" placeholder="输入验证码" v-model="code">
              <!-- <div class="getcode">获取验证码</div> -->
              <span class="getcode" @click="getCode">
                <span v-if="click_status">({{sec}})</span>{{code_text}}
              </span>
            </div>
            <div class="btns">
              <div class="left" @click="toChange(3);">确定</div>
              <div class="right" @click="toChange(1);">返回</div>
            </div>
          </div>

         <div class="step3" v-if="change == 3">
           <div class="title">修改手机号成功</div>
           <p class="new_mobile">当前绑定手机号 : {{newaccount}}</p>
           <div class="back" @click="toChange(1);">返回</div>
         </div>
         <div style="clear: both;"></div>
        </div>


        <div class="password" v-if="type == 2">
          <div class="path" v-if="step != 3">
            <div :class="step == 1 ? 'list checked' : 'list'">
              <img v-show="step != 1" src="../assets/images/mobile_phoneG.png" alt="">
              <img v-show="step == 1" src="../assets/images/mobile_phoneB.png" alt="">
              <p>验证手机号</p>
            </div>
            <div class="line"></div>
            <div :class="step == 2 ? 'list checked' : 'list'">
              <img v-show="step != 2" src="../assets/images/mobile_passwordG.png" alt="">
              <img v-show="step == 2" src="../assets/images/mobile_passwordB.png" alt="">
              <p>重置密码</p>
            </div>
          </div>
          <div class="step" v-if="step == 1">
            <p class="phone_intro">手机号：{{ account }}</p>
            <div class="input">
              <input class="captcha" type="text" placeholder="请输入验证码" v-model="captcha">
              <span class="code_text" @click="getCode">
                <span v-if="click_status">({{sec}})</span>{{code_text}}
              </span>
            </div>
            <div class="btn" @click="checkCode();">下一步</div>
          </div>
          <div class="step" v-if="step == 2">
            <div class="input" style="margin-top: 0.8rem;">
              <input class="newpass" type="password" placeholder="新密码" v-model="newpassword">
            </div>
            <div class="input" style="margin-top: 0.2rem;">
              <input class="repass" type="password" placeholder="确认新密码" v-model="repassword">
            </div>
            <div class="btn" @click="submit();">确定</div>
          </div>
          <div class="step" v-if="step == 3">
            <div class="title">重置密码成功</div>
            <p class="">页面将在5s内自动跳转登录</p>
            <div class="tologin" @click="toLogin">页面没有跳转，点击去登录</div>
          </div>
           <div style="clear: both;"></div>
        </div>
     </div>
  </div>

</template>

<script>
   import VDistpicker from 'v-distpicker'
  import Header from '@/components/Header'
  export default {
    name: "userinfo",
    data(){
      return{
        event:'',
        type:1,
        gender:'男',
        change:1,
        step:1,
        account:'',
        account_text:'',
        code_text:'获取短信验证码',
        sec:60,
        click_status:false,
        interval_id:false,

        province:null,
        city:null,
        area:null,
        provinceId:'',
        cityId:'',
        areaId:'',

        username:'',
        idcard:'',
        headurl:'',
        intro:'',
        school:'',
        company:'',
        wechat:'',
        newaccount:'',
        code:'',
        captcha:'',
        newpassword:'',
        repassword:'',

        Headers:{},
        doUpload:'',
      }
    },
    components: {
      'app-header':Header,
      VDistpicker
    },
    mounted(){
      console.log(this.$route.query.type);
      this.type = this.$route.query.type;
      this.getInfo();
      this.event = JSON.parse(localStorage.getItem('event'));
      this.doUpload = this.url_post+'/trainee/updatephoto'+'?access-token='+localStorage.getItem('token')+'&eventId='+this.event.eventId
    },
    methods:{
      saveInfo(){
        var _this = this;
        var params = {
          eventId:this.event.eventId,
          info:this.intro,
          gender:this.gender,
          schoolName:this.school,
          "wxCard":this.wechat,
        }
        console.log(params);
        this.post('/trainee/updateInfo',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status == 200){
            _this.getInfo();
          }
        })
      },
      getInfo(){
        var _this = this;
        this.post('/trainee/info',{},(data)=>{
          _this.account = data.data.mobile;
          _this.gender = data.data.genderFlag;
          _this.username = data.data.name;
          _this.idcard = data.data.idCard;
          _this.headurl = data.data.photoUrl;
          _this.intro = data.data.info;
         _this.school = data.data.schoolName;
          _this.company = data.data.orgName;
          _this.wechat = data.data.wxCard;

          localStorage.setItem('userinfo',JSON.stringify(data.data));
          console.log(data);
        })
      },
      toLogin(){
        this.$router.replace({path:'/login'});
      },
      submit(){
        var _this = this;
        if(!this.newpassword){
          _this.$mResToast({
            type:'error',
            msg:'请输入新密码',
            duration:3000,
            isIcon:true,
          });
          return;
        }
        if(!this.repassword){
          _this.$mResToast({
            type:'error',
            msg:'请再次输入密码',
            duration:3000,
            isIcon:true,
          });
          return;
        }
        if(this.repassword != this.newpassword){
          _this.$mResToast({
            type:'error',
            msg:'两次密码输入不一致',
            duration:3000,
            isIcon:true,
          });
          return;
        }
        var params = {
          password:_this.newpassword,
          newPassword:_this.repassword,
        }
        this.post('/trainee/updatePassword',params,(data)=>{
          console.log(data);
          if(data.status == 200){
            _this.step = 3;
            setTimeout(function(){
              localStorage.clear();
              _this.toLogin();
            },3000)
          }else{
            _this.$mResToast({
              type:data.status == 200 ? 'success' : 'error',
              msg:data.msg,
              duration:3000,
              isIcon:true,
            });
          }
        })

      },
      toChange(index){
        if(index == 3){
          var _this = this;
          var params = {
            mobile:this.newaccount,
            code:this.code,
          }
          this.post('/trainee/updateMobile',params,(data)=>{
            console.log(data);
            if(data.status == 200){
              _this.change = index;
            }else{
              _this.$mResToast({
                type:data.status == 200 ? 'success' : 'error',
                msg:data.msg,
                duration:3000,
                isIcon:true,
              });
            }
          })
        }else{
          this.change = index;
        }
      },
      checkCode(){
        var _this = this;
        var params = {
          // mobile:this.account,
          code:this.captcha,
        }
        this.post('/checkUserCode',params,(data)=>{
          console.log(data);
          if(data.status == 200){
            _this.step = 2;
          }else{
            _this.$mResToast({
              type:data.status == 200 ? 'success' : 'error',
              msg:data.msg,
              duration:3000,
              isIcon:true,
            });
          }
        })
      },
      sel: function(data) {
        this.provinceId = data.province.code;
        this.cityId = data.city.code;
        this.areaId = data.area.code;

        this.province = data.province.value;
        this.city = data.city.value;
        this.area = data.area.value;
      },
      changeAll(index){
        this.type = index;
        if(this.type != index){
          this.code_text='获取短信验证码';
          this.sec=60;
          this.click_status=false;
          clearInterval(this.interval_id);
          this.interval_id=false;
        }
      },
      getCode(){
        var _this = this;
        if(this.click_status){
          return ;
        }
        var params = {
          // mobile:this.account,
        }
        this.post('/getInfocode',params,(data)=>{
          console.log(data);
          _this.$mResToast({
            type:data.status == 200 ? 'success' : 'error',
            msg:data.msg,
            duration:3000,
            isIcon:true,
          });
          if(data.status != 200) return;
          _this.click_status = true;
          _this.code_text = 'S';
          _this.interval_id = setInterval(()=>{
            if(_this.sec > 1){
              _this.sec--;
            }else{
              _this.sec = 60;
              _this.click_status = false;
              _this.code_text = '重新发送验证码';
              clearInterval(_this.interval_id);
            }
          },1000);
        })
      },
      async handleChange(file) {
           if(!this.canUpload) {
             return false;
           }
           // const bo = await this.$confirm('上传后无法修改, 是否继续?', '提示', {
           //   confirmButtonText: '确定',
           //   cancelButtonText: '取消',
           //   type: 'info'
           //   }).then(() => {
               // console.log('确定上传')
               this.fileName = file.name;
           //     return true;
           //   }).catch(() => {
           //     console.log('取消上传')
           //     return false;
           //   })
           // if (bo) {
             this.$refs.newupload.submit();
             this.canUpload = false;
           // }
       },
       beforeUpload(file){
         var _this = this;
         console.log(file)
         // if(!this.canUpload){
         //   return false;
         // }

         // fd.append('eventId',this.event.eventId);//传其他参数
         // this.post('/reportFile/fileUpload',fd,(res)=>{
           // console.log(res);
           // _this.newSubmitForm();
         // })
       },
       handleSuccess(e){
         var _this = this;
         console.log(e);
         _this.$mResToast({
           type:e.status == 200 ? 'success' : 'error',
           msg:e.msg,
           duration:3000,
           isIcon:true,
         });
         if(e.status == 200){
           this.headurl = e.data;
         }
       },
    }
  }
</script>

<style scoped>
.screen{
  width: 14.5rem;
  height: 0.6rem;
  margin: 0.63rem auto;
}
.screen .now{
  width: 1.4rem;
  height: 0.4rem;
  float: left;
  font-size: 0.21rem;
  color: #4b4b4b;
  text-align: center;
  line-height: 0.4rem;
  margin-top: 0.1rem;
  cursor: pointer;
}
.screen .checked{
  color: #fff;
  background-color: #2b73cc;
}
.screen .line{
  width: 0.02rem;
  height: 0.2rem;
  float: left;
  background-color: #414141;
  margin: 0.2rem 0.1rem;
}

.userinfo{
  width: 100%;
}
.basic{
  width: 11.6rem;
  margin: 0 auto;
}
.basic .title{
  font-size: 0.33rem;
  color: #181818;
}
.basic .step1{
  width: 100%;
}
.basic .step1 .name{
  width: 100%;
  height: 1.4rem;
  margin-top: 0.4rem;
}
.basic .step1 .name .left{
  width: 6.8rem;
  float: left;
}
.basic .step1 .name .left .list{
  width: 100%;
  height: 0.7rem;
  line-height: 0.7rem;
}
.basic .step1 .name .left .list span{
  font-size: 0.25rem;
  color: #7c7c7c;
  float: left;
}
.basic .step1 .name .left .list span .red{
  color: #e60000;
  margin-right: 0.1rem;
}
.basic .step1 .name .left .list input{
  font-size: 0.21rem;
  color: #313131;
  width: 3.4rem;
  height: 0.43rem;
  line-height: 0.43rem;
  padding: 0 0.1rem;
  border: 0.01rem solid #8b8b8b;
  border-radius: 0.1rem;
  outline: none;
  float: left;
  margin-top: 0.14rem;
}
.basic .step1 .name .left .list input::placeholder{
  font-size: 0.21rem;
  color: #7c7c7c;
}
.basic .step1 .name .right{
  width: 4.7rem;
  height: 1.4rem;
  float: left;
}
.basic .step1 .name .right .default{
  width: 1.13rem;
  height: 1.13rem;
  float: left;
  border-radius: 50%;
  margin-right: 0.24rem;
  margin-top: 0.08rem;
}
.basic .step1 .name .right .tips{
  font-size: 0.17rem;
  color: #aeadad;
  float: left;
  width: 2rem;
}
.basic .step1 .name .right .btn{
  width: 1.7rem;
  height: 0.42rem;
  background-color: #2b73cc;
  float: left;
  /* margin-top: 0.25rem; */
  cursor: pointer;
}
.basic .step1 .name .right .btn img{
  width: 0.21rem;
  height: 0.21rem;
  float: left;
  margin: 0.09rem 0.15rem 0 0.17rem;
}
.basic .step1 .name .right .btn span{
  font-size: 0.25rem;
  color: #fff;
  float: left;
  line-height: 0.42rem;
}

.basic .step1 .gender{
  width: 100%;
  font-size: 0.25rem;
  color: #7c7c7c;
  margin-top: 0.4rem;
}
.basic .step1 .gender .text{

}
.basic .step1 .gender label{
  margin-left: 0.2rem;
}
.basic .step1 .gender .val{
  margin-left: 0.1rem;
}

.basic .step1 .intro{
  width: 100%;
  margin: 0.4rem 0;
}
.basic .step1 .intro span{
  font-size: 0.25rem;
  color: #7c7c7c;
  display: block;
}
.basic .step1 .intro textarea{
  width: 9.2rem;
  height: 1.46rem;
  border: 0.01rem solid #6e6e6e;
  font-size: 0.25rem;
  color: #7c7c7c;
  outline: none;
  margin-top: 0.1rem;
  margin-left:0.2rem;
  resize:none;
  padding: 0.1rem;
}

.basic .step1 .distance{
  width: 100%;
  height: 0.5rem;
  margin-top: 0.4rem;
}
.basic .step1 .distance span{
  font-size: 0.25rem;
  line-height: 0.47rem;
  color: #7c7c7c;
  float: left;
  margin-right: 0.2rem;
}
.basic .step1 .distance .distpicker-address-wrapper{
  float: left;
}
.basic .step1 .distance .distpicker-address-wrapper >>> select{
  font-size: 0.25rem;
  color: #7c7c7c;
  outline: none;
  float: left;
  padding: 0;
  width: 2.2rem;
  height: 0.45rem;
  line-height: 0.45rem;
  border-radius: 0.1rem;
  border: 0.01rem solid #8b8b8b;
  margin-right: 0.58rem;
}

.basic .step1 .school{
  width: 100%;
  height: 0.5rem;
  margin-top: 0.26rem;
}
.basic .step1 .school div{
  float: left;
}
.basic .step1 .school span{
  font-size: 0.25rem;
  line-height: 0.45rem;
  color: #7c7c7c;
  float: left;
}
.basic .step1 .school input{
  font-size: 0.21rem;
  color: #313131;
  width: 2.9rem;
  height: 0.43rem;
  line-height: 0.45rem;
  padding: 0 0.1rem;
  border: 0.01rem solid #8b8b8b;
  border-radius: 0.1rem;
  outline: none;
  float: left;
  margin-left: 0.2rem;
}
.basic .step1 .school input::placeholder{
  font-size: 0.23rem;
  line-height: 0.45rem;
  color: #7c7c7c;
}
.basic .step1 .school .left{
  margin-right: 0.8rem;
}
.basic .step1 .school .right{

}

.basic .step1 .mobile{
  width: 100%;
  height: 1.2rem;
  padding-top: 0.66rem;
}
.basic .step1 .mobile .text{
  font-size: 0.25rem;
  color: #7c7c7c;
  float: left;
}
.basic .step1 .mobile .mobile_text{
  font-size: 0.25rem;
  color: #7c7c7c;
  float: left;
}
.basic .step1 .mobile .btn{
  font-size: 0.17rem;
  color: #19cd00;
  width: 1.41rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  border: 1px solid #19cd00;
  float: left;
  margin-left: 0.69rem;
  cursor: pointer;
}
.basic .step1 .mobile p{
  float: left;
  width: 100%;
  height: 0.25rem;
  font-size: 0.17rem;
  color: #8b8b8b;
  margin-top: 0.21rem;
  line-height: 0.25rem;
}
.basic .step1 .mobile p img{
  width: 0.16rem;
  height: 0.16rem;
  float: left;
  margin: 0.04rem 0.1rem 0 0;
}
.basic .step1 .wechat{
  width: 100%;
  margin-top: 0.58rem;
}
.basic .step1 .wechat span{
  font-size: 0.25rem;
  line-height: 0.45rem;
  float: left;
}
.basic .step1 .wechat input{
  font-size: 0.21rem;
  color: #313131;
  width: 2.9rem;
  height: 0.43rem;
  line-height: 0.45rem;
  padding: 0 0.1rem;
  border: 0.01rem solid #8b8b8b;
  border-radius: 0.1rem;
  outline: none;
  float: left;
  margin-left: 0.2rem;
}
.basic .step1 .wechat p{
  float: left;
  width: 100%;
  height: 0.25rem;
  font-size: 0.17rem;
  color: #8b8b8b;
  margin-top: 0.21rem;
  line-height: 0.25rem;
}
.basic .step1 .submit{
  float: left;
  margin: 0.83rem 0;
  width: 2.15rem;
  height: 0.48rem;
  font-size: 0.25rem;
  color: #fff;
  text-align: center;
  line-height: 0.48rem;
  background-color: #2b73cc;
  cursor: pointer;
}

.basic .step2{
  width: 100%;
}
.basic .step2 .now_mobile{
  font-size: 0.25rem;
  color: #7c7c7c;
  margin-top: 1.1rem;
}
.basic .step2 .list{
  width: 100%;
  height: 0.45rem;
  margin-top: 0.26rem;
}
.basic .step2 .list input{
    font-size: 0.21rem;
    color: #313131;
    width: 2.9rem;
    height: 0.43rem;
    line-height: 0.45rem;
    padding: 0 0.1rem;
    border: 0.01rem solid #8b8b8b;
    border-radius: 0.1rem;
    outline: none;
    float: left;
}
.basic .step2 .list .getcode{
  font-size: 0.17rem;
  color: #19cd00;
  width: 1.41rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  border: 1px solid #19cd00;
  float: left;
  margin-left: 0.17rem;
  margin-top: 0.06rem;
  cursor: pointer;
}
.basic .step2 .btns{
  width: 100%;
  height: 0.5rem;
  margin: 0.45rem 0 1rem 0;
}
.basic .step2 .btns div{
  float: left;
  margin-right: 0.73rem;
  width: 2.15rem;
  height: 0.48rem;
  font-size: 0.25rem;
  color: #fff;
  text-align: center;
  line-height: 0.48rem;
  background-color: #2b73cc;
  cursor: pointer;
}

.basic .step3{
  width: 100%;
  margin-top: 1.9rem;
}
.basic .step3 p{
  font-size: 0.25rem;
  color: #7c7c7c;
  margin-top: 0.44rem;
}
.basic .step3 .back{
  float: left;
  width: 2.15rem;
  height: 0.48rem;
  font-size: 0.25rem;
  color: #fff;
  text-align: center;
  line-height: 0.48rem;
  background-color: #2b73cc;
  cursor: pointer;
  margin: 1.58rem 0 2rem 0;
}


.password{
  width: 11.6rem;
  margin: 0 auto;
}
.password .path{
  width: 100%;
  height: 1rem;
}
.password .path .list{
  width: 1.3rem;
  height: 100%;
  float: left;
  margin: 0 0.1rem;
}
.password .path .list img{
  width: 0.54rem;
  height: 0.54rem;
  display: block;
  margin: 0 auto;
}
.password .path .line{
  width: 0.6rem;
  height: 0.85rem;
  border-bottom: 0.03rem dashed #7f7f7f;
  float: left;
}
.password .path .list p{
  float: left;
  width: 100%;
  font-size: 0.25rem;
  height: 0.26rem;
  line-height: 0.26rem;
  color: #7f7f7f;
  text-align: center;
  margin-top: 0.17rem;
}
.password .path .checked{
  border-color: #49d639;
}
.password .path .checked p{
  color: #49d639;
}

.password{
  padding-left: 0.2rem;
  margin-top: 1rem;
}
.password .step{

}
.password .step .title{
  font-size: 0.33rem;
  color: #373737;
}
.password .step .input{
  width: 100%;
  height: 0.5rem;
}
.password .step input{
  float: left;
  width: 3.4rem;
  height: 0.45rem;
  outline: none;
  border: 0.01rem solid #8b8b8b;
  padding: 0 0.1rem;
  border-radius: 0.1rem;
  font-size: 0.21rem;
  color: #bcbcbc;
}
.password .step input::placeholder{
  font-size: 0.21rem;
  color: #bcbcbc;
}
.password .step .btn{
  width: 2.15rem;
  height: 0.48rem;
  font-size: 0.24rem;
  color: #fff;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.48rem;
  margin-top: 0.47rem;
  margin-bottom: 1.1rem;
  cursor: pointer;
}
.password .step .account_intro{
  margin-top: 0.34rem;
}
.password .step p{
  font-size: 0.17rem;
  color: #7c7c7c;
  margin-top: 0.26rem;
}
.password .step .phone_intro{
  font-size: 0.25rem;
  color: #7c7c7c;
  margin-top: 1rem;
  margin-bottom: 0.2rem;
}
.password .step .captcha{
  float: left;
  width: 3.4rem;
  height: 0.45rem;
}
.password .step .code_text{
  float: left;
  font-size: 0.17rem;
  color: #19cd00;
  width: 1.41rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  border: 0.01rem solid #19cd00;
  margin: 0.05rem 0.17rem;
  cursor: pointer;
}
.password .step .tologin{
  width: 5.13rem;
  height: 0.48rem;
  font-size: 0.24rem;
  color: #fff;
  background-color: #2b73cc;
  text-align: center;
  line-height: 0.48rem;
  margin-top: 0.63rem;
  margin-bottom: 2.5rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Userinfo.vue